const T_PREFIX = "inquiry-item";

export const inquiryItemTrns = {
  startDealButton: `${T_PREFIX}.start-deal-btn`,
  addToWatchlistButton: `${T_PREFIX}.add-to-watchlist-btn`,
  removeFromWatchlistButton: `${T_PREFIX}.remove-from-watchlist-btn`,

  similarInquiriesTitle: `${T_PREFIX}.similar-inquiries.title`,
};
